import React, { useEffect, useRef, useState } from "react";
import pdf from "./respublica_marzec.pdf"

const PageGazetaMarch = () => {
  useEffect(() => {
    window.location.href = pdf
  })
};

export default PageGazetaMarch
